<template>
  <div class="row">
    <div class="col-md-12 animated fade-in">
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col-md-11">
              <strong class="card-title mb-3">{{'Themes'}}</strong>
            </div>
            <div class="col-md-1">
              <goback></goback>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row mb5">
            <div class="col-md-3">
              <div class="form-group hidden">
                <input
                  v-model="searchParams.name"
                  class="form-control"
                  name="search"
                  placeholder="Search by Name"
                  @keyup="search"
                />
              </div>
            </div>
            <div class="col-md-7"></div>
            <!-- <div class="col-md-1"></div> -->
            <div class="col-md-2">
              <router-link exact class="btn btn-sm btn-success" :to="addNewLink">
                <i class="fa fa-plus"></i> Add Theme
              </router-link>
            </div>
          </div>
          <div class="table-responsive app" v-dragscroll="true">
            <table id="users" class="table table-sm first-td-padding table-bordered app-inner">
              <thead>
                <tr>
                  <th>Sr.</th>
                  <th v-for="field in tableFields" v-bind:key="'field'+field.title">{{field.title}}</th>
                  <th v-if="actions.length>0">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row,index) in fillableData" v-bind:key="'row'+index">
                  <td>{{index+1}}</td>
                  <td v-for="field in tableFields" v-bind:key="field.name+index">
                    <span v-if="field.name==='name'">{{row['name']}}</span>
                    <span v-else-if="field.name==='role'">{{userRoles[row['role']].value}}</span>
                    <span v-else-if="field.name==='status'">
                      <span
                        class="btn btn-sm btn-success"
                        @click="changeStatus(row)"
                        :class="{'btn-danger': row['status']===0}"
                      >{{(row['status']===0)? 'Inactive':'Active'}}</span>
                    </span>
                    <span v-else>{{row[field.name]}}</span>
                  </td>
                  <td v-if="actions.length>0">
                    <div class="action-btn-wrapper">
                      <span
                        v-for="(action, index) in actions"
                        v-bind:key="index+'-action-'+action.tooltip"
                      >
                        <a
                          style="margin:1px 4px"
                          class="btn btn-sm btn-small"
                          :class="action.btnClass"
                          @click.prevent="action.callback(row,index,$event)"
                        >
                          <i :title="action.tooltip" class="fa" :class="action.icon"></i>
                        </a>
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tfoot v-if="fillableData.length==0">
                <tr>
                  <td :colspan="(tableFields.length+1+actions.length)">
                    <i class="fa fa-info cwhite"></i> No data found.
                  </td>
                </tr>
              </tfoot>
            </table>
            <div class="pull-right" v-if="totalPages>1">
              <ul v-if="this.totalPages != 1" class="pagination">
                <li :class="{disabled:prevDisabled}" class="page-item">
                  <a class="page-link" @click.prevent="goToPage(1)" href="#">&lt;&lt;</a>
                </li>
                <li :class="{disabled:prevDisabled}" class="page-item">
                  <a class="page-link" @click.prevent="prev()" href="#">&lt;</a>
                </li>
                <li
                  v-for="(page, index) in pages"
                  v-bind:key="index+page"
                  class="page-item"
                  :class="(current_page == page)? 'active':''"
                >
                  <a class="page-link" @click.prevent="goToPage(page)" href="#">{{page}}</a>
                </li>
                <li :class="{disabled:nextDisabled}" class="page-item">
                  <a class="page-link" href="#" @click.prevent="next()">&gt;</a>
                </li>
                <li :class="{disabled:nextDisabled}" class="page-item">
                  <a class="page-link" href="#" @click.prevent="goToPage(totalPages)">&gt;&gt;</a>
                </li>
              </ul>
            </div>
          </div>
          <div v-show="show" class="modal-container">
            <div class="modal">
              <div class="modal-dialog modal-sm">
                <div class="modal-content">
                  <!--Header-->
                  <div class="modal-header">
                    <div class="modal-title">
                      <div>{{'Companies selected for ' + selTheme}}</div>
                    </div>
                  </div>
                  <!--Container-->
                  <div class="modal-body">
                    <div class="table-responsive" v-if="companies !== '' || companies.length>0">
                      <table class="table">
                        <tr v-for="(co, ind) in companies" v-bind:key="co.co_code+ind">
                          <td>{{co.companyname}}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <!--Footer-->
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="mt-3 pull-right"
                      :class="'btn btn-sm btn-secondary'"
                      @click="closeCompanyModal"
                      data-dismiss="modal"
                    >Close</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-backdrop"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/lib/http";
export default {
  name: "Themes",
  computed: {},
  created() {
    this.url = this.apiUrl;
    this.$route.query.page
      ? (this.pageToLoad = parseInt(this.$route.query.page))
      : (this.pageToLoad = 1);
    this.url += this.pageToLoad;
    this.current_page = this.pageToLoad;
    this.fetchData(this.searchParams);
  },
  data() {
    return {
      show: false,
      selTheme: "",
      apiUrl: "theme/get/",
      // searchParams: { name: "" },
      searchParams: {},
      fillableData: [],
      url: "theme/get/",
      current_page: 1,
      pageToLoad: 1,
      totalPages: 1,
      prevDisabled: 1,
      nextDisabled: 0,
      pages: [],
      actions: [
        {
          btnClass: "btn-info",
          icon: "fa-list cwhite",
          callback: this.showCompanies,
          tooltip: "Companies"
        },
        {
          btnClass: "btn-success",
          icon: "fa-edit cwhite",
          callback: this.editTheme,
          tooltip: "Edit"
        }
      ],
      tableFields: [
        {
          name: "name",
          title: "Theme Name"
        },
        {
          name: "description",
          title: "Desc."
        },
        {
          name: "longDescription",
          title: "Long Desc."
        },
        {
          name: "sortOrder",
          title: "Sort Order"
        },
        {
          name: "status",
          title: "Status"
        }
      ],
      companies: [],
      addNewLink: "/themes/add"
    };
  },
  methods: {
    search() {
      console.log(this.searchParams);
      if (this.searchParams.name.length > 2) {
        this.fetchData(this.searchParams);
      }
      if (this.searchParams.name.length === 0) {
        console.log("Reset");
        this.reset();
      } else {
        console.log("Not Reset");
      }
      // this.$refs.search.searchIn(this.searchParams);
    },
    reset() {
      // window.location.reload();
      // this.$router.push({ name: "user-listing" });
      this.searchParams = { name: "" };
      this.pageToLoad = 1;
      this.current_page = 1;
      this.url = this.apiUrl; // + this.pageToLoad;
      this.fetchData(this.searchParams);
    },
    fetchData(data) {
      if (this.url !== "") {
        console.log("=====" + this.url + "========");
        let myself = this;
        let params = data ? {} : {};
        // const name =
        //   this.searchParams.name && this.searchParams.name === ""
        //     ? 0
        //     : this.searchParams.name;
        console.log("name", name);
        http.post(this.url, params, function(error, response) {
          console.log(response);
          if (response.data && response.data.length) {
            myself.fillableData = response.data;
            myself.current_page = myself.pageToLoad;
            myself.totalPages = response.total_pages;
            myself.prevDisabled = myself.pageToLoad == 1;
            myself.nextDisabled = myself.current_page == myself.totalPages;
            myself.isLoading = false;
            // set 5 pages to show
            console.log("current", myself.current_page);
            let i = 5;
            let page = myself.current_page - 2;
            if (page <= 0) page = 1;
            myself.pages = [];
            while (i) {
              myself.pages.push(parseInt(page));
              if (myself.totalPages <= page) break;
              page++;
              i--;
            }
            console.log("PAges", myself.pages);
          } else {
            console.log(error);
          }
        });
      } else {
        console.log("=====" + this.url + "========");
      }
    },
    prev() {
      this.pageToLoad = this.current_page - 1;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    goToPage(page) {
      this.pageToLoad = page;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    next() {
      console.log(this.$route.query);
      this.pageToLoad = this.current_page + 1;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    fillTable() {
      let url = this.apiUrl; //+"?a=1"
      if (this.pageToLoad != this.current_page) url += this.pageToLoad;
      this.url = url;
      this.fetchData(this.searchParams);
    },
    remove(index) {
      this.fillableData.splice(index, 1);
    },
    editTheme(row, index, $event) {
      console.log(row, index, $event);
      this.$router.push({
        name: "edit-theme",
        params: { id: row.id }
      });
    },
    showCompanies(row, index, $event) {
      this.selTheme = row.name;
      this.companies = row.companies;
      document.body.className += " modal-open";
      this.show = !this.show;
    },
    closeCompanyModal() {
      this.show = !this.show;
      document.body.className = document.body.className.replace(
        /\s?modal-open/,
        ""
      );
      this.selTheme = "";
      this.companies = [];
    },
    changeStatus(row) {
      var _this = this;
      http.post("theme/update/status", { id: row.id }, (error, response) => {
        console.log(response);
        if (response.responseType === "success") {
          _this.$toastr.success("Status updated successfully.");
          _this.fetchData({});
        } else {
          _this.$toastr.error(
            "Oops, something went wrong! Please try again later."
          );
        }
      });
    }
  }
};
</script>
<style>
.table td {
  padding: 5px 10px 5px 10px;
}
</style>
<style lang="scss">
span.error {
  color: #dc3545;
}
// For Transitioning
.slide-enter-active {
  animation: slide-in 3s fade forwards;
}
.slide-leave-active {
  animation: slide-out 3s fade forwards;
}

@keyframes slide-in {
  from {
    transform: translateY(250px);
  }
  to {
    transform: translateY(0);
  }
}
@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(250px);
  }
}

.modal {
  display: block;
}

.modal-dialog,
.modal-backdrop {
  transition: all 0.5s ease;
}

.modal-enter .modal-dialog,
.modal-leave-active .modal-dialog {
  opacity: 0;
  transform: translateY(-30%);
}

.modal-enter .modal-backdrop,
.modal-leave-active .modal-backdrop {
  opacity: 0;
}

.modal-backdrop {
  opacity: 0.5;
}

//Modal styles

.modal-header {
  height: auto;
  padding: 0 1.6rem;
  border-bottom: 2px solid #eee;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
}

.modal-content {
  border-radius: 0;
}

.modal-footer {
  justify-content: center;
  padding: 0 2px;
  padding-bottom: 5px;
  flex-wrap: wrap;
  .btn {
    margin: 0 10px 20px 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/themes/themes.vue